import { ComponentType } from 'react'
import { Game, GameState } from 'types'
import { formattedTime } from 'shared/timeHelper'

export const ScoreBox: ComponentType<{ game: Game; className?: string }> = ({
  game: { showTime, awayGoals, homeGoals, state, startsAt },
  className
}) => {
  switch (state) {
    case GameState.PRE:
      return (
        <div
          className={`px-2 pt-1 bg-gray-200 rounded-sm flex flex-col justify-center items-center ${
            className || ''
          }`}
        >
          {showTime && (
            <>
              <div className="">{formattedTime(startsAt)}</div>
              <div className="-mt-0.5 uppercase text-xs text-gray-500 text-center font-semibold">
                Uhr
              </div>
            </>
          )}
          {!showTime && <div className="">{'- : -'}</div>}
        </div>
      )

    case GameState.LIVE:
      return (
        <div
          className={`bg-primary text-white rounded-sm py-2 font-bold text-center ${
            className || ''
          }`}
        >
          {homeGoals} : {awayGoals}
        </div>
      )
    case GameState.POST:
      return (
        <div
          className={`bg-black text-white rounded-sm py-2 font-bold text-center ${
            className || ''
          }`}
        >
          {`${homeGoals} : ${awayGoals}`}
        </div>
      )
    case GameState.POSTPONED:
      return (
        <div
          className={`p-2 bg-gray-200 rounded-sm text-center ${
            className || ''
          }`}
        >
          ver.
        </div>
      )
    case GameState.CANCELED:
      return (
        <div
          className={`p-2 bg-gray-200 rounded-sm text-center ${
            className || ''
          }`}
        >
          abg.
        </div>
      )
  }
}
